var map = {
	"./addrounded.svg": 2254,
	"./authoruser.svg": 8732,
	"./blacksearch.svg": 8176,
	"./blackshare.svg": 9229,
	"./bredrightarrow.svg": 1413,
	"./calendericon.svg": 8372,
	"./circledownarrow.svg": 5980,
	"./clock.svg": 7062,
	"./close.svg": 9525,
	"./downarrow.svg": 3300,
	"./facebookcolorround.svg": 2742,
	"./facebookicon.svg": 1318,
	"./followus.svg": 462,
	"./google.svg": 6874,
	"./hoversearch.svg": 9057,
	"./instagramcollection.svg": 6299,
	"./instagramcolorround.svg": 6010,
	"./linkedin.svg": 9097,
	"./linkedinicon.svg": 7358,
	"./longrightarrow.svg": 8123,
	"./mailicon.svg": 8090,
	"./newsletterimg.svg": 4691,
	"./rightarrow.svg": 4599,
	"./rightarrowblue.svg": 9481,
	"./search.svg": 6759,
	"./searchfilter.svg": 8237,
	"./share.svg": 3693,
	"./share2.svg": 2402,
	"./shareblueicon.svg": 9513,
	"./shareicon.svg": 2735,
	"./sliderlefttarrow.svg": 3717,
	"./sliderrightarrow.svg": 872,
	"./telegramcolorround.svg": 7647,
	"./twittercolorround.svg": 8008,
	"./twittericon.svg": 2003,
	"./user-icon.svg": 4382,
	"./user.svg": 6781,
	"./videoicon.svg": 1546,
	"./whatsappcolorround.svg": 1310,
	"./whatsappicon.svg": 9801,
	"./whitedownarrow.svg": 3401,
	"./whiterightarrow.svg": 2284,
	"./whitesearch.svg": 9084,
	"./youtubecolorround.svg": 5219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1006;